
import { StudentData } from './types';

export const calculateSmartExpiry = (gradeLevel: string, academicYear: string, totalDuration: number = 4) => {
    const currentYearStr = academicYear.match(/\d{4}/)?.[0];
    const currentYear = currentYearStr ? parseInt(currentYearStr) : new Date().getFullYear();

    const levelMatch = gradeLevel.match(/\d+/);
    const currentLevel = levelMatch ? parseInt(levelMatch[0]) : 1;

    const yearsRemaining = Math.max(0, totalDuration - currentLevel);
    const expiryYear = currentYear + yearsRemaining;

    return `31/12/${expiryYear}`;
};

export const formatDisplayDate = (dateString?: string) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
